<template>
  <div class="vuetable-filterbar col-md-12">
    <div class="form-group p-l">
      <b-container fluid class="p-a-0">
        <b-row no-gutters>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                type="text"
                class="form-control"
                v-model="cd"
                @keyup.enter="doFilter"
              />
              <label
                class="fl-label"
                for="default-input"
                style="left: 13px; right: 12px"
                >Código</label
              >
            </div>
          </b-col>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px">
            <b-form-datepicker
              locale="pt-br"
              reset-button
              placeholder="Data Inicial"
              v-model="dt_inicio"
              class="form-control"
              :date-format-options="{
                day: 'numeric',
                month: 'numeric',
                year: 'numeric',
              }"
            >
            </b-form-datepicker>
          </b-col>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px">
            <b-form-datepicker
              locale="pt-br"
              reset-button
              placeholder="Data Fim"
              v-model="dt_fim"
              class="form-control"
              :date-format-options="{
                day: 'numeric',
                month: 'numeric',
                year: 'numeric',
              }"
            >
            </b-form-datepicker>
          </b-col>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px">
            <multiselect
                v-model="receita_despesa"
                :options="this.$parent.optionsReceitaDespesa"
                track-by="value"
                label="label"
                :hide-selected="true"
                placeholder="Receita / Despesa"
                tag-placeholder=""
                select-label=""
                selected-label="Selecionado"
                deselect-label="Remover"
            ></multiselect>
          </b-col>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px">
            <multiselect
              v-model="status"
              :options="this.$parent.optionsStatusVigencia"
              track-by="value"
              label="label"
              :hide-selected="true"
              placeholder="Status"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
          </b-col>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px">
            <multiselect
              v-model="tp_tabela"
              :options="this.$parent.optionsTpTabela"
              track-by="value"
              label="label"
              :hide-selected="true"
              placeholder="Tipo Tabela"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
          </b-col>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px">
            <multiselect
              v-model="regiao_origem"
              :options="this.$parent.optionsRegiao"
              track-by="value"
              label="label"
              :hide-selected="true"
              placeholder="Região Origem"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
          </b-col>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px">
            <multiselect
              v-model="regiao_destino"
              :options="this.$parent.optionsRegiao"
              track-by="value"
              label="label"
              :hide-selected="true"
              placeholder="Região Destino"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
          </b-col>
          <b-col sm="6" md="3" class="p-a-0 m-t-5px">
            <multiselect
              v-model="municipio_origem"
              :options="this.$parent.optionsMunicipio"
              track-by="value"
              label="label"
              :hide-selected="true"
              placeholder="Municipio Origem"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
          </b-col>
          <b-col sm="6" md="3" class="p-a-0 m-t-5px">
            <multiselect
              v-model="municipio_destino"
              :options="this.$parent.optionsMunicipio"
              track-by="value"
              label="label"
              :hide-selected="true"
              placeholder="Municipio Destino"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
          </b-col>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px">
            <multiselect
              v-model="tp_rodado"
              :options="this.$parent.optionsParamTipoRodado"
              track-by="value"
              label="label"
              :hide-selected="true"
              placeholder="Tipo Rodado"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
          </b-col>
          <b-col sm="2" md="2" class="p-a-0 m-t-5px">
            <multiselect
              v-model="carga"
              :options="this.$parent.optionsParamTipoCarga"
              track-by="value"
              label="label"
              :hide-selected="true"
              placeholder="Tipo Carga"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
          </b-col>
          <b-col sm="5" md="5" class="p-a-0 m-t-5px">
            <multiselect
              v-model="fornecedor"
              :options-limit="300"
              :limit="10"
              :multiple="true"
              :limit-text="limitText"
              :options="optionsFornecedor"
              track-by="value"
              label="label"
              id="fornecedor"
              :hide-selected="true"
              placeholder="Fornecedor ( Digite 3 caracteres para pesquisar )"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              selected-label="Selecionado"
              deselect-label="Remover"
              :searchable="true"
              :loading="isLoadingFornecedor"
              @search-change="listaFornecedor"
            ></multiselect>
          </b-col>
          <b-col md="5" sm="5" class="p-a-0 m-t-5px">
            <multiselect
              v-model="pessoa"
              :options-limit="300"
              :limit="2"
              :limit-text="limitText"
              :options="optionsPessoa"
              track-by="value"
              label="label"
              id="cliente_ori"
              :hide-selected="true"
              placeholder="Cliente( Digite 3 caracteres para pesquisar )"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              selected-label="Selecionado"
              deselect-label="Remover"
              :searchable="true"
              :loading="isLoadingPessoa"
              @search-change="listaClientesPessoa"
            ></multiselect>
          </b-col>
          <b-col sm="6" md="2" class="m-t-5px">
            <div class="input-group-btn">
              <div class="btn-group">
                <button
                  type="button"
                  class="btn btn-secondary btn-outline"
                  @click="doFilter"
                  :disabled="vuetableFilterButton"
                >
                  Filtrar
                </button>
                <button
                  type="button"
                  class="btn btn-secondary btn-outline"
                  @click="resetFilter"
                  :disabled="vuetableFilterButton"
                >
                  Limpar
                </button>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import moment from "moment";

export default {
  components: {
    Multiselect,
  },
  data() {
    return {
      date_attributes: [{ key: "today", highlight: true, dates: new Date() }],
      helpForm: new Form({ statusRecord: [], params: [], search: "" }),
      isLoadingFor: false,
      isLoadingPessoa: false,
      isLoadingFornecedor: false,
      cd: "",
      descr: "",
      dt_inicio: "",
      dt_fim: "",
      fornecedor: [],
      pessoa: "",
      tp_tabela: [],
      receita_despesa: "",
      municipio_origem: "",
      municipio_destino: "",
      regiao_origem: "",
      regiao_destino: "",
      tp_rodado: [],
      carga: [],
      optionsPessoa: [],
      optionsTpTabela: [],
      optionsStatusVigencia: [],
      optionsRegiao: [],
      optionsParamTipoRodado: [],
      optionsFornecedor: [],
      optionsParamTipoCarga: [],
      status: [],
      data_filter: [],
    };
  },
  mounted() {},
  methods: {
    doFilter() {
      this.$store.commit("setVuetableFilterButton", true);
      this.array_fornecedor = [];
      this.dt_inicio_label = this.dt_inicio;
      this.dt_fim_label = this.dt_fim;
      this.dt_inicio = this.formatDateSubmit(this.dt_inicio);
      this.dt_fim = this.formatDateSubmit(this.dt_fim);
      this.fornecedor.forEach((obj) => {
        this.array_fornecedor.push(obj.pessoa_id)
      });
      this.data_filter = {
        cd: this.cd,
        descr: this.descr,
        status: this.status,
        tp_tabela: this.tp_tabela,
        receita_despesa: this.receita_despesa,
        fornecedor: this.array_fornecedor,
        pessoa: this.pessoa,
        municipio_origem: this.municipio_origem,
        municipio_destino: this.municipio_destino,
        regiao_origem: this.regiao_origem,
        regiao_destino: this.regiao_destino,
        tp_rodado: this.tp_rodado,
        carga: this.carga,
        dt_inicio: this.dt_inicio,
        dt_fim: this.dt_fim,
      };
      this.$events.fire("filter-set", this.data_filter);
      this.dt_inicio = this.dt_inicio_label;
      this.dt_fim = this.dt_fim_label;
    },
    resetFilter() {
      this.cd = ""; // clear the text in text input
      this.descr = "";
      this.pessoa = "";
      this.status = "";
      this.tp_tabela = "";
      this.receita_despesa = "";
      this.fornecedor = "";
      this.municipio_origem = "";
      this.municipio_destino = "";
      this.regiao_origem = "";
      this.regiao_destino = "";
      this.tp_rodado = "";
      this.carga = "";
      this.dt_inicio = "";
      this.dt_fim = "";
      
      this.$events.fire("filter-reset");
    },
    listaFornecedor(search) {
      if (search.length >= 3) {
        this.isLoadingFornecedor = true;
        this.helpForm.search = search;
        this.helpForm.status = 1;
        this.helpForm
          .post("/api/pessoa/jsonlist/fornecedor")
          .then((response) => {
            this.optionsFornecedor = [];
            new ReturnApi(response, this, true, false, false);
            if (response.items.length > 0) {
              response.items.forEach((obj) => {
                this.optionsFornecedor.push({
                  label:
                    "PJ -" +
                    obj.pessoa.cd +
                    " - " +
                    obj.razao_social +
                    " - " +
                    this.onFormataCnpj(
                      obj.cnpj_base,
                      obj.cnpj_filial,
                      obj.cnpj_digito
                    ) +
                    " - " +
                    obj.inscricao_estadual,
                  pessoa_id: obj.pessoa_id,
                  value: obj.pessoa_id,
                });
              });
            }
            if (response.itemsF.length > 0) {
              response.itemsF.forEach((obj) => {
                this.optionsFornecedor.push({
                  label: "PF -" + obj.nome + " - " + obj.cpf,
                  pessoa_id: obj.pessoa_id,
                  value: obj.pessoa_id,
                });
              });
            }
            if (response.itemsE.length > 0) {
              response.itemsE.forEach((obj) => {
                this.optionsFornecedor.push({
                  label: "PE -" + obj.nome + " - " + obj.cd,
                  pessoa_id: obj.pessoa_id,
                  value: obj.pessoa_id,
                });
              });
            }
            this.isLoadingFornecedor = false;
          })
          .catch((errors) => {
            new ReturnApi(errors, this);
          });
      }
    },
    listaClientesPessoa(search) {
      if (search.length >= 3) {
        this.isLoadingPessoa = true;
        this.helpForm.search = search;
        this.helpForm.status = 1;
        this.helpForm
          .post("/api/pessoa/jsonlist")
          .then((response) => {
            this.optionsPessoa = [];
            new ReturnApi(response, this, true, false, false);
            if (response.items.length > 0) {
              response.items.forEach((obj) => {
                this.optionsPessoa.push({
                  label:
                    "PJ -" +
                    obj.pessoa.cd +
                    " - " +
                    obj.razao_social +
                    " - " +
                    this.onFormataCnpj(
                      obj.cnpj_base,
                      obj.cnpj_filial,
                      obj.cnpj_digito
                    ) +
                    " - " +
                    obj.inscricao_estadual,
                  value: obj.pessoa_id,
                });
              });
            }
            if (response.itemsF.length > 0) {
              response.itemsF.forEach((obj) => {
                this.optionsPessoa.push({
                  label: "PF -" + obj.nome + " - " + obj.cpf,
                  value: obj.pessoa_id,
                });
              });
            }
            if (response.itemsE.length > 0) {
              response.itemsE.forEach((obj) => {
                this.optionsPessoa.push({
                  label: "PE -" + obj.nome + " - " + obj.cd,
                  value: obj.pessoa_id,
                });
              });
            }
            this.isLoadingPessoa = false;
          })
          .catch((errors) => {
            new ReturnApi(errors, this);
          });
      }
    },
    limitText(count) {
      return " e ${count} outros clientes";
    },
    formatDateSubmit(value, fmt = "DD/MM/YYYY") {
      return value == null || value == ""
        ? ""
        : moment(value, "YYYY/MM/DD HH:mm").format(fmt);
    },
    onFormataCnpj(cnpj_base, cnpj_filial, cnpj_digito) {
      var cnpj_formatado;
      var pad = "00000000";
      var cnpj_base =
        pad.substring(0, pad.length - cnpj_base.toString().length) + cnpj_base;
      var pad = "0000";
      var cnpj_filial =
        pad.substring(0, pad.length - cnpj_filial.toString().length) +
        cnpj_filial;
      var pad = "00";
      var cnpj_digito =
        pad.substring(0, pad.length - cnpj_digito.toString().length) +
        cnpj_digito;

      return cnpj_base + "" + cnpj_filial + "" + cnpj_digito;
    },
  },
  computed: {
    vuetableFilterButton: {
      get() {
        return this.$store.state.vuetable.filterButton;
      },
    },
  },
};
</script>
